import React, { useMemo } from "react"
import IconButton from "./IconButton"

const ClearButton = ({ focused, value, onClear }) => {
	const button = useMemo(() => ({
		icon: 'remove',
		hidden: !focused || !value,
		handler: onClear,
		ui: 'decline'
	}), [focused, value, onClear])

	return <IconButton
		button={button}
	/>
}

export default ClearButton